/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_gcskew_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`It depends on sequence length — a few hundred to a few thousand bases for whole genomes, smaller for short sequences. The tool clamps the window to the sequence length if needed.`)
};

const es_gcskew_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Depende de la longitud de la secuencia — de unos cientos a unos miles de bases para genomas completos, menos para secuencias cortas. La herramienta limita la ventana a la longitud de la secuencia si es necesario.`)
};

const de_gcskew_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das hängt von der Sequenzlänge ab — einige hundert bis einige tausend Basen für ganze Genome, kleiner für kurze Sequenzen. Das Tool passt das Fenster bei Bedarf an die Sequenzlänge an.`)
};

const nl_gcskew_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dit hangt af van de sequentielengte — een paar honderd tot een paar duizend basen voor hele genomen, kleiner voor korte sequenties. De tool beperkt het venster tot de sequentielengte indien nodig.`)
};

const fr_gcskew_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cela dépend de la longueur de la séquence — quelques centaines à quelques milliers de bases pour des génomes entiers, plus petite pour des séquences courtes. L'outil limite la fenêtre à la longueur de la séquence si nécessaire.`)
};

const it_gcskew_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dipende dalla lunghezza della sequenza — da poche centinaia a poche migliaia di basi per genomi interi, più piccola per sequenze corte. Lo strumento limita la finestra alla lunghezza della sequenza se necessario.`)
};

const pt_br2_gcskew_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Depende do comprimento da sequência — algumas centenas a alguns milhares de bases para genomas completos, menor para sequências curtas. A ferramenta ajusta a janela ao comprimento da sequência se necessário.`)
};

const pt_gcskew_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Depende do comprimento da sequência — algumas centenas a alguns milhares de bases para genomas inteiros, menos para sequências curtas. A ferramenta ajusta a janela ao comprimento da sequência se necessário.`)
};

const ja_gcskew_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`配列の長さによります — ゲノム全体では数百から数千塩基、短い配列ではより小さくします。必要に応じて、ツールは窓サイズを配列長にクランプします。`)
};

const zh_gcskew_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`这取决于序列长度——对于完整基因组，通常为几百到几千个碱基，短序列则应使用更小的窗口。如有需要，工具会将窗口大小限制在序列长度以内。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const gcskew_faq_a3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.gcskew_faq_a3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("gcskew_faq_a3", locale)
	if (locale === "en") return en_gcskew_faq_a3(inputs)
	if (locale === "es") return es_gcskew_faq_a3(inputs)
	if (locale === "de") return de_gcskew_faq_a3(inputs)
	if (locale === "nl") return nl_gcskew_faq_a3(inputs)
	if (locale === "fr") return fr_gcskew_faq_a3(inputs)
	if (locale === "it") return it_gcskew_faq_a3(inputs)
	if (locale === "pt-BR") return pt_br2_gcskew_faq_a3(inputs)
	if (locale === "pt") return pt_gcskew_faq_a3(inputs)
	if (locale === "ja") return ja_gcskew_faq_a3(inputs)
	return zh_gcskew_faq_a3(inputs)
};